import React, {Component} from 'react'
import {Page} from '@shopify/polaris'
import JobCrawlers from './JobCrawlers'

class JobCrawlersContainer extends Component {
    render() {
        return (
            <Page fullWidth title="Job Crawlers">
                <JobCrawlers {...this.props}/>
            </Page>
        )
    }
}

export default JobCrawlersContainer
